import { render, staticRenderFns } from "./AbrFormPanelWrapper.vue?vue&type=template&id=0be7d52f"
import script from "./AbrFormPanelWrapper.vue?vue&type=script&lang=js"
export * from "./AbrFormPanelWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports